import { render, staticRenderFns } from "./m-bag-prices.vue?vue&type=template&id=b48bbdf4&scoped=true"
import script from "./m-bag-prices.vue?vue&type=script&lang=js"
export * from "./m-bag-prices.vue?vue&type=script&lang=js"
import style0 from "./m-bag-prices.vue?vue&type=style&index=0&id=b48bbdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48bbdf4",
  null
  
)

export default component.exports